// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a37671b4","455":"68df972c","977":"7d435d25"}[chunkId] + ".chunk.js";
};